import {User} from 'auth/user'
import FeaturePage from 'Event/template/Lefty/Page'
import {
  FeaturePageTitle,
  PageTexts,
  StyledConfigurable,
} from 'Event/template/Lefty/Page'
import React from 'react'
import {useLeftyTemplate} from 'Event/template/Lefty'
import {useAttendeeVariables} from 'Event'
import SponsorList from 'Event/template/Lefty/Sponsors/SponsorList'
import {LeftyBreadcrumbs} from 'Event/template/Lefty/Page'
import AddLeftySponsorButton from 'Event/template/Lefty/Sponsors/AddLeftySponsorButton'
import SponsorsHeaderConfig from 'Event/template/Lefty/Sponsors/SponsorsHeaderConfig'

export default function Sponsors(props: {user: User}) {
  const template = useLeftyTemplate()
  const {sponsors} = template
  const v = useAttendeeVariables()

  return (
    <FeaturePage user={props.user}>
      <StyledConfigurable>
        <SponsorsHeaderConfig />
        <>
          <FeaturePageTitle aria-label="sponsors title">
            {v(sponsors.title)}
          </FeaturePageTitle>
          <LeftyBreadcrumbs page={v(sponsors.title)} />
          <PageTexts
            title={sponsors.secondaryTitle}
            description={sponsors.description}
          />
        </>
      </StyledConfigurable>
      <SponsorList />
      <AddLeftySponsorButton />
    </FeaturePage>
  )
}
